// src/routes/index.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { setTitle } from "../utils/core";

import OrderConfirmation from "../pages/OrderConfirmation";
import OrderCancellation from "../pages/OrderCancellation";
import Dashboard from "../pages/Dashboard";
import NotFound404 from "../pages/NotFound404";

const routes = [
  {
    name: "continue payment",
    path: "/",
    component: <Dashboard />,
  },
  {
    name: "Payment Complete",
    path: "/payment-success",
    component: <OrderConfirmation />,
  },
  {
    name: "Payment Cancel",
    path: "/payment-cancel",
    component: <OrderCancellation />,
  },
];

const getRoutes = () => {
  return routes.map((route) => {
    setTitle(route);
    return (
      <Route
        key={route.path}
        exact
        path={route.path}
        element={route.component}
      />
    );
  });
};

const Approutes = ({}) => {
  return (
    <BrowserRouter>
      <Routes>
        {getRoutes()}

        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Approutes;
